import to from '@/lib/to'

export const HEARTBEAT_INTERVAL_MS = 60000

export const END_REASONS = {
  EXPECTED: 'expected',
  UNEXPECTED: 'unexpected',
  TIMEOUT: 'timeout'
}

export class PatientMonitorConnectionTracker {
  constructor(http) {
    this.http = http
    this.connectionId = null
    this.heartbeatTimer = null
  }

  get isTracking() {
    return this.connectionId !== null
  }

  async connect(patientMonitorId, source, sessionId) {
    if (this.isTracking) {
      return this.connectionId
    }

    const [err, response] = await to(this.http.post('/patient_monitor_connections', {
      patient_monitor_id: patientMonitorId,
      source,
      session_id: sessionId
    }, { skipLoading: true, handleErrors: true }))

    if (!err && response?.data?.id) {
      this.connectionId = response.data.id
      this.startHeartbeat()
    }

    return this.connectionId
  }

  async disconnect(endReason = END_REASONS.EXPECTED) {
    this.stopHeartbeat()

    if (!this.connectionId) {
      return
    }

    await to(this.http.put(`/patient_monitor_connections/${this.connectionId}/disconnect`, {
      end_reason: endReason
    }, { skipLoading: true, handleErrors: true }))

    this.connectionId = null
  }

  startHeartbeat() {
    this.stopHeartbeat()
    this.heartbeatTimer = setInterval(() => {
      if (this.connectionId) {
        to(this.http.put(`/patient_monitor_connections/${this.connectionId}`, {}, {
          skipLoading: true,
          skipInactivityCheck: true,
          handleErrors: true
        }))
      }
    }, HEARTBEAT_INTERVAL_MS)
  }

  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }
}
